var map = {
	"./01.png": 7442,
	"./02.png": 3529,
	"./03.png": 7280,
	"./04.png": 3151,
	"./05.png": 4134,
	"./06.png": 5341,
	"./07.png": 8660,
	"./08.png": 3955,
	"./09.png": 8746,
	"./10.png": 672,
	"./11.png": 4873,
	"./12.png": 338,
	"./13.png": 1883,
	"./14.png": 7076,
	"./15.png": 317,
	"./16.png": 8550,
	"./17.png": 2351,
	"./18.png": 5288,
	"./19.png": 3681,
	"./20.png": 8709,
	"./21.png": 1196,
	"./22.png": 9927,
	"./23.png": 6286,
	"./24.png": 3025,
	"./25.png": 312,
	"./26.png": 4803,
	"./27.png": 4042,
	"./28.png": 637,
	"./29.png": 9508,
	"./30.png": 5082,
	"./Avatar-2.png": 8021,
	"./Avatar.png": 4560,
	"./Hyper1.png": 696,
	"./Knight.png": 3660,
	"./Ship01.png": 8084,
	"./Ship02.png": 543,
	"./Ship03.png": 1798,
	"./Ship04.png": 425,
	"./Ship05.png": 4672,
	"./Ship06.png": 75,
	"./Ship07.png": 6418,
	"./Ship08.png": 7285,
	"./Ship09.png": 9772,
	"./Zoom.png": 8850,
	"./Zoom1.png": 6641,
	"./Zoom2.png": 6058,
	"./bg.png": 8682,
	"./border9.png": 3564,
	"./chesst1.png": 2942,
	"./chesst2.png": 293,
	"./collection.png": 1295,
	"./comet.png": 5543,
	"./comet2.png": 3493,
	"./comet3.png": 6956,
	"./logo.png": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;